<div class="main-content-wrapper" data-testid="main-content-wrapper">
  <!-- Departmets and fav departments navBar-->
  <div class="dept-navbar me-5" data-testid="dept-navbar">
    <button
      class="nav-link d-flex align-items-center"
      [class.active]="isButtonActive == false"
      (click)="toggleButton1()"
      data-testid="favorites-btn"
    >
      {{ "Favorites" | translate }}
      <span id="favQty" class="ms-2" data-testid="favorites-qty">{{ favQuantity }}</span>
    </button>
    <button
      class="nav-link"
      [class.active]="isButtonActive == true"
      (click)="toggleButton2()"
      data-testid="all-departments-btn"
    >
      {{ "All Departments" | translate }}
    </button>
  </div>
  <!-- Departmets and fav departments Content-->
  <div class="dept-wrapper mt-3" data-testid="dept-wrapper">
    <div class="row" *ngIf="isButtonActive == true" data-testid="departments-row">
      <div
        class="col-xl-3 col-md-4 col-sm-6 position-relative"
        *ngFor="let dept of mainDepartmentList"
        data-testid="department-card"
      >
        <div
          class="dept-content"
          (click)="getSelectedDepartmentData(dept, dept.departmentDescr)"
          data-testid="department-content"
        >
          <div class="icon" data-testid="department-icon">
            <img
              class="img-fluid"
              (click)="getSelectedDepartmentData(dept, dept.departmentDescr)"
              [src]="
                dept.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'
              "
              (error)="dept.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'"
              data-testid="department-img"
            />
          </div>
          <h6
            (click)="getSelectedDepartmentData(dept, dept.departmentDescr)"
            data-testid="department-title"
          >
            {{ dept.departmentDescr }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align: end" data-testid="department-fav-icon">
          <i
            class="fa-regular fa-star fa-xl"
            *ngIf="!dept.isFav"
            (click)="fav(dept)"
            data-testid="department-fav-unselected"
          ></i>
          <i
            class="fa-solid fa-star fa-xl"
            style="color: #eda519"
            *ngIf="dept.isFav"
            (click)="fav(dept)"
            data-testid="department-fav-selected"
          ></i>
        </div>
      </div>
    </div>

    <!--Row for displaying fav items-->
    <div class="row" *ngIf="isButtonActive == false" data-testid="favorites-row">
      <div
        class="col-xl-3 col-md-4 col-sm-6 position-relative"
        *ngFor="let favItem of combinedItemsList"
        data-testid="favorite-card"
      >
        <div
          class="dept-content"
          (click)="getSelectedDepartmentData(favItem, favItem.departmentDescr)"
          data-testid="favorite-content"
        >
          <div
            class="icon"
            (click)="
              getSelectedDepartmentData(favItem, favItem.departmentDescr)
            "
            data-testid="favorite-icon"
          >
            <img
              class="img-fluid"
              [src]="
                favItem.imageIcon || 'assets/Pos-Catalog/akar-icons_image.svg'
              "
              (error)="favItem.imageIcon = 'assets/Pos-Catalog/akar-icons_image.svg'"
              data-testid="favorite-img"
            />
          </div>
          <h6
            (click)="
              getSelectedDepartmentData(favItem, favItem.departmentDescr)
            "
            data-testid="favorite-title"
          >
            {{
              favItem.subCategoryId
                ? favItem.departmentDescr +
                  " / " +
                  favItem.categoryName +
                  " / " +
                  favItem.subCategoryName
                : favItem.categoryName != null
                ? favItem.departmentDescr + " / " + favItem.categoryName
                : favItem.departmentDescr
            }}
          </h6>
        </div>
        <div class="favrIcon" style="text-align: end" data-testid="favorite-fav-icon">
          <i
            class="fa-solid fa-star fa-xl"
            style="color: #eda519"
            (click)="fav(favItem)"
            data-testid="favorite-fav-selected"
          ></i>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Boostrap modal for showing warning -->
<button
  #stationWarning
  class="d-none"
  data-bs-target="#stationWarningModal"
  data-bs-toggle="modal"
  data-testid="station-warning-btn"
></button>
<div
  class="modal fade"
  id="stationWarningModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
  data-bs-backdrop="static"
  data-testid="station-warning-modal"
>
  <div class="modal-dialog modal-dialog-centered" data-testid="station-warning-dialog">
    <div class="modal-content" data-testid="station-warning-content">
      <div class="custom-modal-header modal-header pb-0" data-testid="station-warning-header">
        <h5 class="mb-0" data-testid="station-warning-title">
          {{
            stationslist.length
              ? "License Limit Reached!"
              : "No Stations Available"
          }}
        </h5>
      </div>
      <div class="custom-modal-body modal-body" data-testid="station-warning-body">
        <div class="modal-body-wraapper" *ngIf="stationslist.length" data-testid="station-warning-license-limit">
          <p style="font-size: 14px">
            You have been logged out due to license limits.
          </p>
          <p style="font-size: 14px">
            The maximum number of active licenses has been reached. Please
            contact your administrator for assistance.
          </p>
          <p style="font-size: 14px">We apologize for any inconvenience.</p>
        </div>
        <div class="modal-body-wraapper" *ngIf="!stationslist.length" data-testid="station-warning-no-stations">
          <p style="font-size: 14px">
            There are no station license available for
            {{ defaultStoreName }} Store.
          </p>
          <p style="font-size: 14px">Please contact your administrator.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer pt-0" data-testid="station-warning-footer">
        <button
          class="btn modal-btn"
          style="cursor: pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="logOutUser()"
          data-testid="station-warning-ok-btn"
        >
          Okay
        </button>
      </div>
    </div>
  </div>
</div>
